import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-watch",
  imports: [CommonModule],
  templateUrl: "./skeleton-watch.component.html",
  styleUrl: "./skeleton-watch.component.scss",
})
export class SkeletonWatchComponent {}
